import { FC } from 'react';

import {
  EmptyState as EmptyStateBase,
  EmptyStateImageVariant,
  EmptyStateVariant,
} from '../../../../components/empty-state/index';
import { StatusFilter } from '../../../../types/general.types';
import { PerkStatusFilter, PerkStatusFilterUnion } from '../table.types';

type SearchEmptyStateProps = {
  filter: PerkStatusFilterUnion;
  search: string;
};

const filterTitleTranslationKeyMap: Record<PerkStatusFilterUnion, string> = {
  [StatusFilter.ALL]: 'No Perks found',
  [StatusFilter.ACTIVE]: 'No Active Perks',
  [StatusFilter.INACTIVE]: 'No Inactive Perks',
  [PerkStatusFilter.DRAFTS]: 'No Draft Perks',
};
const filterDescriptionTranslationKeyMap: Record<PerkStatusFilterUnion, string> = {
  [StatusFilter.ALL]: 'When available, perks will be displayed here',
  [StatusFilter.ACTIVE]: 'Active perks will be displayed here once they added',
  [StatusFilter.INACTIVE]: 'Inactive perks will be displayed here once they added',
  [PerkStatusFilter.DRAFTS]: 'Drafted perks will be displayed here once they added',
};

export const SearchEmptyState: FC<SearchEmptyStateProps> = ({ filter, search }) => {
  return (
    <EmptyStateBase
      colorScheme={EmptyStateVariant.BEIGE}
      description={search ? 'Please try again' : filterDescriptionTranslationKeyMap[filter]}
      imageVariant={EmptyStateImageVariant.BRIEFCASE}
      text={search ? 'No results match this search term' : filterTitleTranslationKeyMap[filter]}
    />
  );
};
